import numeral from 'numeral';
import React from 'react';
import styled, { css } from 'styled-components';
const PercentStat = styled.span `
  display: inline-block;
  color: ${({ stat, theme }) => stat >= 1 ? theme.colors.darkMint : theme.colors.coral};
  white-space: nowrap;

  &:before {
    content: '';
    display: inline-block;
    position: relative;
    top: -2px;
    left: -2px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;

    ${({ stat, theme }) => stat >= 1
    ? css `
            border-bottom: 5px solid ${theme.colors.darkMint};
          `
    : css `
            border-top: 5px solid ${theme.colors.coral};
          `}
  }
`;
export const numericDeltaColumnRenderer = (value) => {
    const percent = Math.abs(value).toFixed(0);
    return value ? React.createElement(PercentStat, { stat: value },
        percent,
        "%") : undefined;
};
export const createNumericColumnRenderer = (opts) => {
    return (value) => numeral(value).format(opts?.format ?? '0,0');
};
export const defaultNumericColumnRenderer = createNumericColumnRenderer();
